export class KundSearchParamsModel {
    id?: number;
    sokTypeAhead?: string;
    namn?: string;
    orgNummer?: string;
    besokPostortadress?: string;
    huvudkod?: string;
    internnummer?: string;
    limeId?: string;
    aktiv?: boolean;
    beskrivning?: string;
    befraktare?: boolean;

    constructor() {
        this.id = null;
        this.sokTypeAhead = null;
        this.namn = null;
        this.orgNummer = null;
        this.besokPostortadress = null;
        this.huvudkod = null;
        this.internnummer = null;
        this.limeId = null;
        this.aktiv = null;
        this.beskrivning = null;
        this.befraktare = null;
    }
}
